export const OFFER_TRANSLATION_NAMESPACE = "offer";

export const OFFER_TK = "OFFER_TK";
export const SPONSORED_ADDS_CREATE_FORM_TK = "SPONSORED_ADDS_CREATE_FORM_TK";
